import {
  WIZARD_ERROR_MESSAGE,
} from "../../../../../wizard/constants";
import { TValidator } from "../../../../../wizard/types";
import { validateExamsGroup } from "../../../validators/validators";

type CommonObject = { [key: string]: any };

const validator: TValidator = async ({ values, activeStepName }) => {
  const errors: CommonObject = {};
  const notifyMessages: string[] = [];
  errors.mainExams = [];
  errors.addedExams = [];

  const stepValues = values[activeStepName] ?? {};

  // Exams --------------------------------------------------------
  const allExams = [
    ...(stepValues.mainExams || []),
    ...(stepValues.addedExams || []),
  ].filter((exam) => exam && (exam.name?.trim() || exam.score?.trim()));

  // check is at least 2 exams entered
  if (allExams.length < 2) {
    const message = "Please enter at least two exams";
    errors.exams = message;
    notifyMessages.push(message);
  }

  // check exam names duplications --------------------------------
  const allExamsNames = allExams.reduce((names, exam) => {
    return exam?.name?.trim() ? [...names, exam.name.trim()] : names;
  }, []);

  if (new Set(allExamsNames).size !== allExamsNames.length) {
    const message = "There are exams with the same name";
    errors.exams = message;
    notifyMessages.push(message);
  }

  // check if exam has name, mark score as required
  // check if exam has score , mark name as required
  validateExamsGroup(stepValues.mainExams, "mainExams", errors);
  validateExamsGroup(stepValues.addedExams, "addedExams", errors);

  if (
    errors.mainExams.length > 0 ||
    errors.addedExams.length > 0 ||
    Object.keys(errors).length - 2 > 0
  ) {
    throw {
      [WIZARD_ERROR_MESSAGE]: notifyMessages.join("\n\n"),
      [activeStepName]: errors,
    };
  }
};

export default validator;
